export default __webpack_public_path__ + "static/media/switchOpen.f68c0ad1.svg";